export default __webpack_public_path__ + "static/media/service_introduction.b1b28813.png";